import * as Yup from 'yup';
import { ILenderUtility } from '../../interfaces';

type Picked =
  | 'id'
  | 'autoSubmitLoanApplication'
  | 'autoSubmitConfiguration';

export type TLenderUtilityAutoSubmitForm = Pick<ILenderUtility, Picked>;

export const lenderUtilityAutoSubmitFormSchema = Yup.object().shape({
    active: Yup.boolean().required(),
    autoSubmit: Yup.string(),
    condition: Yup.string().when('active', {
      is: true,
      then: Yup.string().required('A condition must be selected when active is true').nullable(),
      otherwise: Yup.string().nullable(),
    }),
    value: Yup.string().when('active', {
      is: true,
      then: Yup.string().required('Value is required when active is true').nullable(),
      otherwise: Yup.string().nullable(),
    }),
});
